import { BufOrStr } from '../types';
import { BomEncoding } from './detectBom.types';
import { startsWith } from './utils';

export const boms: ReadonlyArray<Readonly<[BomEncoding, Buffer]>> = [
	['utf8', Buffer.from('EFBBBF', 'hex')],

	['utf32be', Buffer.from('0000FEFF', 'hex')],
	// Could be confused with utf16le followed by \0 byte
	['utf32le', Buffer.from('FFFE0000', 'hex')],

	['utf16be', Buffer.from('FEFF', 'hex')],
	['utf16le', Buffer.from('FFFE', 'hex')],

	// Multiple for UTF7
	['utf7', Buffer.from('2B2F7638', 'hex')],
	['utf7', Buffer.from('2B2F7639', 'hex')],
	['utf7', Buffer.from('2B2F762B', 'hex')],
	['utf7', Buffer.from('2B2F762F', 'hex')],
	['utf7', Buffer.from('2B2F76382D', 'hex')],
];

export function detectBom(buf: BufOrStr): BomEncoding | undefined {
	for (const [enc, bomBuf] of boms) {
		if (buf.length >= bomBuf.length) {
			if (startsWith(buf, bomBuf)) {
				return enc;
			}
		}
	}
}

export function getBomLength(bomEnc: Omit<BomEncoding, 'utf7'>): number {
	if (bomEnc === 'utf8') {
		return 3;
	} else if (bomEnc === 'utf16le' || bomEnc === 'utf16be') {
		return 2;
	} else {
		// UTF32
		return 4;
	}
}
